// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isCdiJobErrorsResult = objectOf({
  app_group_id: string,
  integration_id: string,
  integration_type: string,
  warehouse: string,
  job_id: string,
  error_type: string,
  error_message: string,
  payload: string,
  id_values: string,
  error_timestamp: string,
  sf_created_at: string,
  id: string,
});
